import { Historial } from '../objeto_historial';
import { RegistrarPagos } from '../objeto_servicio';
import {convertirFechaFirebase,conversionStringJson,conversionNumberJson,conversionFechaJson, conversionBooleanoJson, parsearParaContenidoEnriquecido, parsearContenido} from '../utiles_objetos';

// models/Solicitud.js
//solicitud
export class Solicitud {
constructor({
      id = 0,
      Servicio = "", //"TALLER","TESIS"
      idcotizacion = 0,
      materia = "",
      fechaentrega = new Date(),
      resumen = "",
      infocliente = "",
      cliente = 0,
      fechasistema = new Date(),
      Estado = "",
      cotizaciones = [],
      archivos = "",
      ultimaModificacion = 0,
      tutorVistaSolicitud = [],
      solicitudVisible = true,
      preguntas = [],
      creadoPor = "",
      contenidoEnriquecido = [],
      referidoPor = "",
      interesesTesis = [],
      nombreEmpresa = "",
      historial = [],
      objetoFaltante = {},
      proPlataforma = {},
      noVisible = false,

      //automatico
      globalId = "",

      //mas cosas
      codigoReferenciaCamapa = "",

      //ia
      generateExplicacionIa = "",
      predicionesIA = {},

      //nuevas variables, precio a cliente
      precioCobradoCliente = 0,
      
      //ultimo intento de solicitud
      ultimoIntentoSolicitud = false,

      //pagos
      pagos = [],
      tutorSeleccionado = "", //seleccionamos el nombre del tutor, que en las cotizaciones se selecciona el precio del tutor
      //pagos sin tutor seleccionado ajustar

    } = {}) {
      this.id = id;
      this.Servicio = Servicio;
      this.idcotizacion = idcotizacion;
      this.materia = materia;
      this.fechaentrega = fechaentrega instanceof Date ? fechaentrega : new Date(fechaentrega);
      this.resumen = resumen;
      this.infocliente = infocliente;
      this.cliente = cliente;
      this.fechasistema = fechasistema instanceof Date ? fechasistema : new Date(fechasistema);
      this.Estado = Estado;
      this.cotizaciones = cotizaciones;
      this.archivos = archivos;
      this.ultimaModificacion = ultimaModificacion;
      this.tutorVistaSolicitud = tutorVistaSolicitud;
      this.solicitudVisible = solicitudVisible;
      this.preguntas = preguntas;
      this.creadoPor = creadoPor;
      this.contenidoEnriquecido = contenidoEnriquecido;
      this.referidoPor = referidoPor;
      this.interesesTesis = interesesTesis;
      this.nombreEmpresa = nombreEmpresa;
      this.historial = historial;
      this.objetoFaltante = objetoFaltante;
      this.proPlataforma = proPlataforma;
      this.noVisible = noVisible;

      //automatico
      this.globalId = globalId;

      //
      this.codigoReferenciaCamapa = codigoReferenciaCamapa;

      //generate IA
      this.generateExplicacionIa = generateExplicacionIa;
      this.predicionesIA = predicionesIA;

      //INFOO NUEVA
      this.precioCobradoCliente = precioCobradoCliente;
      this.ultimoIntentoSolicitud = ultimoIntentoSolicitud;

      //PAGOS
      this.pagos = pagos;

}
  
// Método para crear una solicitud a partir de datos JSON
//TODO BIEN - 
static fromJson(json) {

      const fechaEntregaLocal = convertirFechaFirebase(json['fechaentrega']);
      const fechaSistemaLocal = convertirFechaFirebase(json['fechasistema']);
      const idLocal = json['idcotizacion'] || 0;
      const nombreEmpresaLocal = json['nombreEmpresa'] || "Error, no deberia salir";

      const historial =  Array.isArray(json['historial']) 
        ? json['historial'].map(historialDATA => Historial.fromJson(historialDATA))
        : [];

       const pagos =  Array.isArray(json['pagos']) 
        ? json['pagos'].map(pagosDATA => RegistrarPagos.fromJson(pagosDATA))
        : [];

      return new Solicitud({
        id: idLocal,
        Servicio: json['Servicio'] || "", 
        idcotizacion: json['idcotizacion'] || 0,
        materia: json['materia'] || "",
        fechaentrega: fechaEntregaLocal,
        resumen: json['resumen'] || "",
        infocliente: json['infocliente'] || "",
        cliente: json['cliente'] || 0,
        fechasistema: fechaSistemaLocal,
        Estado: json['Estado'] || "",

        //Listas
        cotizaciones: (json['cotizaciones'] || []).map(cotizacionData => Cotizacion.fromJson(cotizacionData)),

        tutorVistaSolicitud: (json['tutorVistaSolicitud'] || []).map(tutorvistaData => VistaTutorCotizacion.fromJson(tutorvistaData)),
        
        preguntas: (json['preguntas'] || []).map(preguntasData => Preguntas.fromJson(preguntasData)),

        historial: historial,

        //objeto
        objetoFaltante: json.objetoFaltante || null,

        archivos: json['archivos'] || "",
        ultimaModificacion: json['ultimaModificacion'] || 0,
        solicitudVisible: json['solicitudVisible'] ?? true,
        creadoPor: json['creadoPor'] || "",
        interesesTesis: json.interesesTesis || [],

        contenidoEnriquecido: json['contenidoEnriquecido'] || [],
        referidoPor: json['referidoPor'] || "",
        nombreEmpresa: nombreEmpresaLocal,

        //proplataforma
        proPlataforma: json.proPlataforma ? ProPlataforma.fromJson(json.proPlataforma) : new ProPlataforma(),

        //materia = materia de la plataforma
        //fase = fase de la plataforma
        //plataforma = "de donde es?"
        //SERVICIO A
        //UNIINCA
        //UNAD
        //POLITECNICO NUEVA GRANADA
        noVisible: json['noVisible'] || false,

        //automatico
        globalId: json['globalId'] || `${nombreEmpresaLocal}_${idLocal}`,

        codigoReferenciaCamapa: json['codigoReferenciaCamapa'] || ``,
        generateExplicacionIa: json['generateExplicacionIa'] || ``,
        predicionesIA:  json['predicionesIA'] || {},
          //carreraIa
          //carreraSugerencia
          //materiaIA
          //materiaSugerencia
        precioCobradoCliente: json['precioCobradoCliente'] || 0,

        ultimoIntentoSolicitud:  json['ultimoIntentoSolicitud'] || false,

        //pagos
        pagos: pagos,

      });
}

toJson(){
  return{

  }
}

//los pagos no pueden estar en tomap, son solo las que son pagadas por clientes
toMap(){
  return {
    'idcotizacion' : conversionNumberJson(this.idcotizacion,0),
    'Servicio': conversionStringJson(this.Servicio, ''),
    'materia': conversionStringJson(this.materia, ''),
    'fechaentrega': conversionFechaJson(this.fechaentrega, new Date()),
    'resumen': conversionStringJson(this.resumen, ''),
    'cliente': conversionNumberJson(this.cliente, 0),
    'fechasistema': conversionFechaJson(this.fechasistema, new Date()),
    'Estado': "DISPONIBLE",
    'ultimaModificacion': conversionNumberJson(this.ultimaModificacion, Date.now()),
    'solicitudVisible': this.solicitudVisible,
    'creadoPor': conversionStringJson(this.creadoPor, ''),
    'referidoPor': conversionStringJson(this.referidoPor, ''),
    'nombreEmpresa': conversionStringJson(this.nombreEmpresa, ''),

    //este no se puede mover
    'contenidoEnriquecido': this.contenidoEnriquecido,

    'historial': this.historial,

    'objetoFaltante': this.objetoFaltante !== null && this.objetoFaltante !== undefined
      ? (typeof this.objetoFaltante.toMap === 'function' 
          ? this.objetoFaltante.toMap(this.objetoFaltante) 
          : this.objetoFaltante)
      : null,
    'proPlataforma': this.proPlataforma !== null && this.proPlataforma !== undefined
      ? (typeof this.proPlataforma.toMap === 'function' 
        ? this.proPlataforma.toMap(this.proPlataforma) // <--- El argumento es innecesario
        : this.proPlataforma)
    : null,
    'cotizaciones': this.cotizaciones.map(cotizacion => cotizacion.toMap()),
    'tutorVistaSolicitud' : this.tutorVistaSolicitud,
    'noVisible': this.noVisible,
    'codigoReferenciaCamapa' : this.codigoReferenciaCamapa,
    'pagos': this.pagos.map(pago => pago.toMap()),
  };
}

toNotify(){
  return {
    'idcotizacion' : conversionNumberJson(this.idcotizacion,0),
    'Servicio': conversionStringJson(this.Servicio, ''),
    'materia': conversionStringJson(this.materia, ''),
    'fechaentrega': conversionFechaJson(this.fechaentrega, new Date()),
    'resumen': conversionStringJson(this.resumen, ''),
    'cliente': conversionNumberJson(this.cliente, 0),
    'fechasistema': conversionFechaJson(this.fechasistema, new Date()),
    'Estado': "DISPONIBLE",
    'ultimaModificacion': conversionNumberJson(this.ultimaModificacion, Date.now()),
    'solicitudVisible': this.solicitudVisible,
    'creadoPor': conversionStringJson(this.creadoPor, ''),
    'referidoPor': conversionStringJson(this.referidoPor, ''),
    'nombreEmpresa': conversionStringJson(this.nombreEmpresa, ''),

    'historial': this.historial,

    'objetoFaltante': this.objetoFaltante !== null && this.objetoFaltante !== undefined
      ? (typeof this.objetoFaltante.toMap === 'function' 
          ? this.objetoFaltante.toMap(this.objetoFaltante) 
          : this.objetoFaltante)
      : null,
    'proPlataforma': this.proPlataforma !== null && this.proPlataforma !== undefined
      ? (typeof this.proPlataforma.toMap === 'function' 
        ? this.proPlataforma.toMap(this.proPlataforma) 
        : this.proPlataforma)
    : null,
    'cotizaciones': this.cotizaciones,
    'noVisible': this.noVisible,
  };
}

//actualizar cad acosa del update
updateFromJson(updateData) {
  console.log("🔄 updateFromJson ejecutándose con:", updateData);
  
  if (!updateData || typeof updateData !== 'object') {
    console.warn('updateData debe ser un objeto válido');
    return;
  }

  Object.keys(updateData).forEach(field => {
    const value = updateData[field];
    console.log(`🔧 Procesando campo: ${field}, tipo: ${typeof value}`);

    switch(field) {
      // Números
      case 'id':
        this.id = conversionNumberJson(value, this.id);
        break;
      case 'idcotizacion':
        this.idcotizacion = conversionNumberJson(value, this.idcotizacion);
        break;
      case 'cliente':
        this.cliente = conversionNumberJson(value, this.cliente);
        break;
      case 'ultimaModificacion':
        this.ultimaModificacion = conversionNumberJson(value, this.ultimaModificacion);
        break;

      // Strings
      case 'Servicio':
        this.Servicio = conversionStringJson(value, this.Servicio);
        break;
      case 'materia':
        this.materia = conversionStringJson(value, this.materia);
        break;
      case 'resumen':
        this.resumen = conversionStringJson(value, this.resumen);
        break;
      case 'infocliente':
        this.infocliente = conversionStringJson(value, this.infocliente);
        break;
      case 'Estado':
        this.Estado = conversionStringJson(value, this.Estado);
        break;
      case 'archivos':
        this.archivos = conversionStringJson(value, this.archivos);
        break;
      case 'creadoPor':
        this.creadoPor = conversionStringJson(value, this.creadoPor);
        break;
      case 'referidoPor':
        this.referidoPor = conversionStringJson(value, this.referidoPor);
        break;
      case 'nombreEmpresa':
        this.nombreEmpresa = conversionStringJson(value, this.nombreEmpresa);
        break;

      // Fechas
      case 'fechaentrega':
        this.fechaentrega = conversionFechaJson(value, this.fechaentrega);
        break;
      case 'fechasistema':
        this.fechasistema = conversionFechaJson(value, this.fechasistema);
        break;

      // ✅ CAMPOS FALTANTES AGREGADOS
      case 'contenidoEnriquecido':
        this.contenidoEnriquecido = Array.isArray(value) ? value : this.contenidoEnriquecido;
        break;
      
      case 'objetoFaltante':
        if (value && typeof value === 'object') {
          this.objetoFaltante = value;
        }
        break;

      case 'objetoFaltante.temaTesis':
        this.objetoFaltante.temaTesis = conversionStringJson(value, this.objetoFaltante.temaTesis);
        break;

      case 'objetoFaltante.carrera':
        this.objetoFaltante.carrera = conversionStringJson(value, this.objetoFaltante.carrera);
        break;

      case 'objetoFaltante.universidad':
        this.objetoFaltante.universidad = conversionStringJson(value, this.objetoFaltante.universidad);
        break;

      case 'objetoFaltante.cantidadPaginas':
        this.objetoFaltante.cantidadPaginas = conversionStringJson(value, this.objetoFaltante.cantidadPaginas);
        break;

      case 'objetoFaltante.normasCitacion':
        this.objetoFaltante.normasCitacion = conversionStringJson(value, this.objetoFaltante.normasCitacion);
        break;

      case 'objetoFaltante.temasExamen':
        this.objetoFaltante.temasExamen = conversionStringJson(value, this.objetoFaltante.temasExamen);
        break;

      case 'objetoFaltante.duracionExamen':
        this.objetoFaltante.duracionExamen = conversionStringJson(value, this.objetoFaltante.duracionExamen);
        break;
        
      case 'objetoFaltante.formatoEntrega':
        this.objetoFaltante.formatoEntrega = conversionStringJson(value, this.objetoFaltante.formatoEntrega);
        break;

      case 'objetoFaltante.numeroHoras':
        this.objetoFaltante.numeroHoras = conversionStringJson(value, this.objetoFaltante.numeroHoras);
        break;

      //proplataforma general
      case 'proPlataforma':
        if (value && typeof value === 'object') {
          // Si viene un objeto completo, crear nueva instancia de ProPlataforma
          this.proPlataforma = ProPlataforma.fromJson(value);
        } else if (value === null || value === undefined) {
          // Si viene null o undefined, mantener el valor actual o crear uno nuevo
          this.proPlataforma = this.proPlataforma || new ProPlataforma();
        }
        console.log(`✅ proPlataforma actualizado:`, this.proPlataforma);
        break;
      
      //PROPLATAFORMA
      case 'proPlataforma.materia':
        this.proPlataforma.materia = conversionStringJson(value, this.proPlataforma.materia);
        break;

      case 'proPlataforma.fase':
        this.proPlataforma.fase = conversionStringJson(value, this.proPlataforma.fase);
        break;

      case 'proPlataforma.plataforma':
        this.proPlataforma.plataforma = conversionStringJson(value, this.proPlataforma.plataforma);
        break;

      case 'proPlataforma.manejoPlataforma':
        this.proPlataforma.manejoPlataforma = conversionBooleanoJson(value, this.proPlataforma.manejoPlataforma)
        break;

      case 'proPlataforma.noPlataforma':
          this.proPlataforma.noPlataforma = conversionBooleanoJson(value, this.proPlataforma.noPlataforma)
          break;

       case 'proPlataforma.semestre':
          this.proPlataforma.semestre = conversionStringJson(value, this.proPlataforma.semestre);
          break;

      case 'proPlataforma.precioEmpresa':
        this.proPlataforma.precioEmpresa = conversionNumberJson(value, this.proPlataforma.precioEmpresa);
        break;

      case 'proPlataforma.costoEmpresa':
        this.proPlataforma.costoEmpresa = conversionNumberJson(value, this.proPlataforma.costoEmpresa);
        break;

      case 'proPlataforma.fechaRealUnad':
        this.proPlataforma.fechaRealUnad = conversionFechaJson(value, this.proPlataforma.fechaRealUnad);
        break;

      case 'proPlataforma.esColaborativo':
        this.proPlataforma.esColaborativo = conversionBooleanoJson(value, this.proPlataforma.esColaborativo);
        break;

      case 'proPlataforma.tieneForo':
        this.proPlataforma.tieneForo = conversionBooleanoJson(value, this.proPlataforma.tieneForo);
        break;

      
      
      case 'historial':
        this.historial = Array.isArray(value) ? value : this.historial;
        break;
      
      case 'cotizaciones':
        this.cotizaciones = Array.isArray(value) ? value : this.cotizaciones;
        break;
      
      case 'preguntas':
        this.preguntas = Array.isArray(value) ? value : this.preguntas;
        break;
      
      case 'tutorVistaSolicitud':
        this.tutorVistaSolicitud = Array.isArray(value) ? value : this.tutorVistaSolicitud;
        break;
      
      case 'interesesTesis':
        this.interesesTesis = Array.isArray(value) ? value : this.interesesTesis;
        break;
      
      case 'solicitudVisible':
        this.solicitudVisible = typeof value === 'boolean' ? value : this.solicitudVisible;
        break;

      case 'precioCobradoCliente':
        this.precioCobradoCliente = conversionNumberJson(value, this.precioCobradoCliente);
        break;

      case 'ultimoIntentoSolicitud' :
        this.ultimoIntentoSolicitud = conversionBooleanoJson(value, this.ultimoIntentoSolicitud);
        break;

      default:
        console.warn(`Campo desconocido en update data de Solicitudes: ${field}`);
        break;
    }
  });
  
  console.log("✅ updateFromJson completado");
}

//hallar field 
// Agregar este método a la clase Solicitud
getFieldValue(fieldPath) {
  console.log(`🔍 Obteniendo valor para: ${fieldPath}`);
  
  if (fieldPath.includes('.')) {
    const [objectName, fieldName] = fieldPath.split('.');
    const value = this[objectName]?.[fieldName];
    console.log(`📦 Valor anidado ${objectName}.${fieldName}:`, value);
    return value;
  }
  
  const value = this[fieldPath];
  console.log(`📝 Valor directo ${fieldPath}:`, value);
  return value;
}

esProPlataforma() {
  // Asegurarse de que proPlataforma exista y no sea nulo.
  if (!this.proPlataforma) {
    return false;
  }

  // Verificar si alguna de las propiedades clave tiene un valor distinto al predeterminado.
  const tieneMateria = this.proPlataforma.materia && this.proPlataforma.materia.trim() !== "NO ASIGNADO";
  //const tieneFase = this.proPlataforma.fase && this.proPlataforma.fase.trim() !== "";
  //const tienePlataforma = this.proPlataforma.plataforma && this.proPlataforma.plataforma.trim() !== "";
  //const requiereManejo = this.proPlataforma.manejoPlataforma === true;

  // Si al menos una de estas condiciones es verdadera, se considera ProPlataforma.
  return tieneMateria ;//|| tieneFase || tienePlataforma || requiereManejo;
}

//validar pagos
getSumaPagosClientes() {

  if (!this.pagos || !Array.isArray(this.pagos)) {
    return 0;
  }

  return this.pagos
    .filter(pago => pago.tipopago === 'CLIENTES')
    .reduce((total, pago) => total + (parseFloat(pago.valor) || 0), 0);
    
}

}

//objeto cotizacion
export class Cotizacion {
  constructor({
    cotizacion = 0,
    nombretutor = "",
    comentariocotizacion = "",
    fechaconfirmacion = new Date(), 

    //utilidad
    solicitudData = {},
  } = {}){
    this.cotizacion = cotizacion;
    this.nombretutor = nombretutor;
    this.comentariocotizacion = comentariocotizacion;
    this.fechaconfirmacion = fechaconfirmacion;

    this.solicitudData = solicitudData;
  }

  static fromJson(json){

    const fechaConfirmacionlOCAL = convertirFechaFirebase(json['fechaconfirmacion']);

    //cambio permitidio el 14/08/2025, es mas facil cambiar esto que cambiar toda la app
    const cotizacionFinal = json['cotizacion'] ?? json['Cotizacion'] ?? 0;
    const comentarioFinal = json['comentariocotizacion'] ?? json['Comentario Cotización'] ?? '';

    return new Cotizacion({
      cotizacion: cotizacionFinal,
      nombretutor: json['nombretutor'] || "",
      comentariocotizacion: comentarioFinal,
      fechaconfirmacion: fechaConfirmacionlOCAL,

      //utilidad
      solicitudData: json.solicitudData ? Solicitud.fromJson(json.solicitudData) : new Solicitud(),

    });

  }

  // Método toJson para la clase Materia
  toJson() {
    return {
      'cotizacion': this.cotizacion,
      'nombretutor': this.nombretutor,
      'comentariocotizacion': this.comentariocotizacion,
      'fechaconfirmacion': this.fechaconfirmacion instanceof Date ? this.fechaconfirmacion.toISOString() : this.fechaconfirmacion,
    };
  }

  toMap(){
    return{
      'cotizacion': conversionNumberJson(this.cotizacion),
      'nombretutor': conversionStringJson(this.nombretutor),
      'comentariocotizacion': conversionStringJson(this.comentariocotizacion),
      'fechaconfirmacion': conversionFechaJson(this.fechaconfirmacion ),
    }
  }

  updateFromJson(updateData){
    if (!updateData || typeof updateData !== 'object') {
            console.warn('updateData debe ser un objeto válido');
            return;
    }

    Object.keys(updateData).forEach(field => {
            const value = updateData[field];
            console.log(`🔧 Procesando campo: ${field}, tipo: ${typeof value}`);

            switch(field) {
                case 'cotizacion':
                    this.cotizacion = conversionNumberJson(value,this.cotizacion);
                    break;

                case 'nombretutor':
                    this.nombretutor = conversionStringJson(value,this.nombretutor);
                    break;

                case 'comentariocotizacion':
                    this.comentariocotizacion = conversionStringJson(value,this.coticomentariocotizacionzacion);
                    break;

                case 'fechaconfirmacion':
                    this.fechaconfirmacion = conversionFechaJson(value,this.fechaconfirmacion);
                    break;
          
            }

         });

  }

  getFieldValue(fieldPath) {
        console.log(`🔍 Obteniendo valor para: ${fieldPath}`);
        
        if (fieldPath.includes('.')) {
            const [objectName, fieldName] = fieldPath.split('.');
            const value = this[objectName]?.[fieldName];
            console.log(`📦 Valor anidado ${objectName}.${fieldName}:`, value);
            return value;
        }
        
        const value = this[fieldPath];
        console.log(`📝 Valor directo ${fieldPath}:`, value);
        return value;
  }

}
//Vista de cotizacion por tutor
export class VistaTutorCotizacion {
  constructor({
    nombreTutor = "",
    fechaConfirmacion = new Date(),
  } = {}){
    this.nombreTutor = nombreTutor;
    this.fechaConfirmacion = fechaConfirmacion;
  }

  static fromJson(json){

    const fechaConfirmacionlOCAL = convertirFechaFirebase(json['fechaConfirmacion']);

    return new VistaTutorCotizacion({
      nombreTutor: json['nombreTutor'] || 0,
      fechaConfirmacion : fechaConfirmacionlOCAL,
    });

  }

  toJson(){

  }

  toMap(){

  }

}

//objeto faltante
export class objetoFaltante{
  constructor({
    //tesis
    temaTesis = "",
    carrera = "",
    universidad = "",
    cantidadPaginas = "",
    normasCitacion = "",

    //examenes
    temasExamen = "",
    duracionExamen = "",

    //trabajos
    formatoEntrega = "",

    //asesorias
    numeroHoras = "",
  } = {}){
    this.temaTesis = temaTesis;
    this.carrera = carrera;
    this.universidad = universidad;
    this.cantidadPaginas = cantidadPaginas;
    this.normasCitacion = normasCitacion;
    this.temasExamen = temasExamen;
    this.duracionExamen = duracionExamen;
    this.formatoEntrega = formatoEntrega;
    this.numeroHoras = numeroHoras;
  }

  static fromJson(json){

    return new objetoFaltante({

    });

  }

  toJson(){
    return{

    }
  }

  toMap(){
    return{

    }
  }

}

//objeto de preguntas
export class Preguntas{
  constructor({
    id = "",
    pregunta = null,
    fechaPregunta = new Date(),
    nombreTutor = "",

    respuesta  = "",
    fechaRespuesta  = new Date(),
    nombreAsesor  = "",
  } = {}){
    this.id = id;
    this.pregunta = pregunta;
    this.fechaPregunta = fechaPregunta;
    this.nombreTutor = nombreTutor;

    this.respuesta = respuesta;
    this.fechaRespuesta = fechaRespuesta;
    this.nombreAsesor = nombreAsesor;
  }

  static fromJson(json){

    const fechaPreguntaLocal = convertirFechaFirebase(json['fechaPregunta']);
    const fechaRespuestaLocal = convertirFechaFirebase(json['fechaRespuesta']);

    //preguntas y respuestas a contneido enriquecido
    const preguntaLocal = parsearParaContenidoEnriquecido(json['pregunta']);
    const respuestaLocal = parsearParaContenidoEnriquecido(json['respuesta']);

    console.log("pregunta local tenemos",respuestaLocal);

    return new Preguntas({
      id: json['id'] || '',
      pregunta: preguntaLocal,
      fechaPregunta: fechaPreguntaLocal,
      nombreTutor: json['nombreTutor'] || '',
      
      respuesta: respuestaLocal,
      fechaRespuesta: fechaRespuestaLocal,
      nombreAsesor: json['nombreAsesor'] || '',
    });
  }


  toJson(){

  }

  toMap(){

  }

}

//para plataforma
export class ProPlataforma{
  constructor({
    materia = 'NO ASIGNADO',
    fase = "NA",
    plataforma = "NA",
    manejoPlataforma = true, //manejo de plataforma es para el cliente, pero si estan en plataforma
    semestre = "NA",
    noPlataforma = true, // no es un trabajo de plataforma
    //fecha real
    fechaRealUnad = new Date(),
    precioEmpresa = 0,
    costoEmpresa = 0,

    //Servicio revisado? , nuevas varaibles
    esColaborativo = false,
    tieneForo = false,


  } = {}){
    this.materia = materia;
    this.fase = fase;
    this.plataforma = plataforma;
    this.manejoPlataforma = manejoPlataforma;
    this.semestre = semestre;
    this.noPlataforma = noPlataforma;
    this.fechaRealUnad = fechaRealUnad;
    this.precioEmpresa = precioEmpresa;
    this.costoEmpresa = costoEmpresa;

    this.esColaborativo = esColaborativo;
    this.tieneForo = tieneForo;
  }

  static fromJson(json){
    const fechaRealUnadConvertido = convertirFechaFirebase(json['fechaRealUnad']);

    try{
      return new ProPlataforma({
      materia :  json['materia'] ?? 'NO ASIGNADO',
      fase: json['fase'] || 'NA',
      plataforma: json['plataforma'] || 'NA',
      manejoPlataforma: json['manejoPlataforma'] ?? true,
      semestre: json['semestre'] || 'NA',
      noPlataforma: json['noPlataforma'] ?? true, //si es true, se maneja, si es false no se maneja
      fechaRealUnad: fechaRealUnadConvertido,
      precioEmpresa: json['precioEmpresa'] || 0,
      costoEmpresa: json['costoEmpresa'] || 0,

      esColaborativo: json['esColaborativo'] ?? true,
      tieneForo: json['tieneForo'] ?? true,

    });
    }
    catch(error){
      console.warn("error fromsjon en objeto proplataforma ",json);
    }
    
  }

  toJson(){

  }

  toMap(){
     return{
      'materia' : conversionStringJson(this.materia),
      'fase' : conversionStringJson(this.fase),
      'plataforma' : conversionStringJson(this.plataforma),
      'manejoPlataforma' : conversionStringJson(this.manejoPlataforma),
      'semestre' : conversionStringJson(this.semestre),
      'noPlataforma' : conversionBooleanoJson(this.noPlataforma),
      'fechaRealUnad' : conversionFechaJson(this.fechaRealUnad),
      'precioEmpresa' : conversionNumberJson(this.precioEmpresa),
      'costoEmpresa' : conversionNumberJson(this.costoEmpresa),
      "esColaborativo": conversionBooleanoJson(this.esColaborativo),
      "tieneForo": conversionBooleanoJson(this.tieneForo),
    };
  }

}